import React from 'react'
import { useQuery } from '@apollo/client'
import { citationIdFromMeLink } from '@chegg-wt/core/utils/projects'
import { LoadingDots } from '@chegg-wt/core/components/LoadingDots'
import { ErrorMsgs } from '@chegg-wt/core/constants/errorMsgs'
import { aliasToStyleId } from '@chegg-wt/core/utils/styles'
import { Citation } from '@chegg-wt/core/types/redux-citation-api'
import { GET_FORMATTED_FOOTNOTEV2 } from '@chegg-wt/core/oneGraphQueries/FormattedCitations'
import {
  GetFormattedFootnoteV2,
  GetFormattedFootnoteV2Variables,
} from '@chegg-wt/core/oneGraphQueries/__generated__/GetFormattedFootnoteV2'
import { Modal } from '../index'
import * as Styled from './styled'
import InTextModal from './InTextModal'
import { FootnoteModal } from './FootnoteModal'
import { PREMIUM_COPY_MODAL_ID } from './testIds'

interface Props {
  citation: Citation
  isFootnote: boolean
  currentStyle: string
  showModal?: boolean
  onClose?: () => void
}

const FootnoteContent = ({ isLoading, error, footnote }) => {
  if (isLoading) {
    return <LoadingDots message="Loading footnote contents" />
  }

  if (error || !footnote) {
    return (
      <Styled.FootnoteErrorContainer>
        <Styled.FootnoteErrorText>
          {ErrorMsgs.GET_FOOTNOTE_ERROR}
        </Styled.FootnoteErrorText>
      </Styled.FootnoteErrorContainer>
    )
  }

  return <FootnoteModal footnote={footnote} />
}

export const PremiumCopyModal: React.FC<Props> = ({
  showModal,
  citation,
  isFootnote,
  currentStyle,
  onClose,
}) => {
  const {
    data: footnoteDataV2,
    loading: isFootnoteLoadingV2,
    error: footnoteErrorV2,
  } = useQuery<GetFormattedFootnoteV2, GetFormattedFootnoteV2Variables>(
    GET_FORMATTED_FOOTNOTEV2,
    {
      variables: {
        citationProjectId: citation.projectId,
        citationId: citationIdFromMeLink(citation.id),
        citationStyle: aliasToStyleId(currentStyle),
      },
      skip: !isFootnote,
      ssr: false,
      fetchPolicy: 'cache-and-network',
      context: { clientName: 'oneGraph' },
    }
  )

  return (
    <Modal showModal={showModal || true} closeButton onClose={onClose}>
      <div data-test={PREMIUM_COPY_MODAL_ID}>
        <Styled.HeaderContainer>
          <Styled.Header>{isFootnote ? 'Footnote' : 'In-text'} citation</Styled.Header>
        </Styled.HeaderContainer>
        {isFootnote && (
          <FootnoteContent
            isLoading={isFootnoteLoadingV2}
            error={footnoteErrorV2}
            footnote={footnoteDataV2?.citation?.formattedCitationFootnoteV2}
          />
        )}
        {!isFootnote && <InTextModal citation={citation} style={currentStyle} />}
      </div>
    </Modal>
  )
}

export default PremiumCopyModal
